import * as React from 'react';
import { resolvePositioningShorthand, usePositioning } from '@fluentui/react-positioning';
/**
 * Hook used to handle positioning of the popup.
 *
 * @param props - DatePicker props
 * @returns tuple of trigger and popup refs
 * @internal
 */
export function usePopupPositioning(props) {
  const {
    positioning
  } = props;
  const popupOptions = {
    position: 'below',
    align: 'start',
    ...resolvePositioningShorthand(positioning)
  };
  const {
    targetRef,
    containerRef
  } = usePositioning(popupOptions);
  return [targetRef, containerRef];
}
//# sourceMappingURL=usePopupPositioning.js.map